import { Pipe, PipeTransform } from '@angular/core';

import { formatRecurrenceRule } from '@shared/utils';

@Pipe({
  name: 'recurrenceRule',
  standalone: true,
})
export class RecurrenceRulePipe implements PipeTransform {
  transform(value?: string): string {
    return formatRecurrenceRule(value);
  }
}
